import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import React, { Suspense } from "react";
import { articles } from "../articles";
import { useParams } from "react-router";
import { NotFoundBody } from "./NotFound";

const articlesObject = articles;
function Dynamic() {
  const Empty = NotFoundBody;
  let { eventId } = useParams();
  const dynamicComponent = (() => {
    const MyComponent = articlesObject[eventId] ? articlesObject[eventId] : Empty;
    return <MyComponent key={eventId} />;
  })();

  return (
    <>
      <Suspense fallback={<div className="w-screen h-screen">Loading…</div>}>{dynamicComponent}</Suspense>
    </>
  );
}

export default function ArticleBody() {
  return (
    <div className="w-full h-full">
      <Navbar />
      <Dynamic />
      <Footer />
    </div>
  );
}
